import { render, staticRenderFns } from "./GiteaAccountModal.vue?vue&type=template&id=33b8d2eb&"
import script from "./GiteaAccountModal.vue?vue&type=script&lang=js&"
export * from "./GiteaAccountModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "GiteaAccountModal.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/modals/providers/GiteaAccountModal.vue
// module id = 2353
// module chunks = 1